import {
  NOTIFICATION_ERROR_CSS_CLASS,
} from './constants';
// import logger from '../ErrorBoundary/logger';
// import { logError, FE_API_ERROR, FE_API_JS_ERROR } from '../../../services/loggerService';
// import { loadScripts } from '../Tagging/index';

export const hideNotification = () => ({
  type: 'common/HIDE_NOTIFICATION',
});

// Do not use this outside of showErrorNotification, if you use this you are doing some wrong! - Edwin Badillo Mendez
/* const errorTagging = (errorMsg, errorCode, errorName) => {
  try {
    if (!window && !window.vzwDL) {
      // loadScripts();
      setTimeout(() => { callAnalyticsEvent(errorMsg, errorCode, errorName); }, 1000);
    } else {
      callAnalyticsEvent(errorMsg, errorCode, errorName);
    }
  } catch (error) {
  }
}; */
// const callAnalyticsEvent = (errorMsg, errorCode, errorName) => {
//   // Everything inside here is owned by tagging team (David Hsu)
//   // eslint-disable
//   (function eventTracker(n) {
//     const eventName = 'errorEvent';
//     const params = {
//       errorMsg,
//       errorCode,
//       errorName,
//     };
//     if (n++ < 30) {
//       (!window.vzwAnalytics || document.readyState !== 'complete' || typeof window.s === 'undefined') ? setTimeout(() => { eventTracker(n); }, 750) : vzwAnalytics.events.track(eventName, params);
//     } else {
//       window.errorCode = errorCode;
//       window.errorMessage = errorMsg;
//     }
//   }(0));
//   // eslint-enable
// };

export const showErrorNotification = (message, section, networkError, errorName, scrollId) => {
  //
  // errorTagging(message, undefined, errorName);

  // Removing html elements as the team managing this data does not want it.
  // Do not remove or alter this code, any new logging request please go to Edwin Badillo Mendez
  const elem = document.createElement('div');
  elem.textContent = message;
  // elem.dangerouslySetInnerHTML = { __html: message };

  return {
    type: 'common/SHOW_NOTIFICATION',
    data: {
      message, section, type: NOTIFICATION_ERROR_CSS_CLASS, scrollId,
    },
  };
};

export const setHeight = (height) => ({
  type: 'common/SET_HEIGHT',
  data: { height },
});
